import React from "react";
import { ChoiceGroup, IChoiceGroupOption, Icon } from "@fluentui/react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { freemiumMessages } from "../messages";

export const ActivationPlan = ({
  value,
  setValue,
}: {
  value: string;
  setValue: (v: string) => void;
}) => {
  const intl = useIntl();

  const options: IChoiceGroupOption[] = [
    {
      key: "startFreeware",
      text: "Free",
      onRenderField: () => (
        <PlanCard selected={value === "startFreeware"}>
          <Title>{intl.formatMessage(freemiumMessages.freeTitle)}</Title>
          <SubTitle>{intl.formatMessage(freemiumMessages.freeSubtitle)}</SubTitle>
          <List>
            <ListItem>
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.freeItem1)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.freeItem2)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.freeItem3)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.freeItem4)}
            </ListItem>
          </List>
        </PlanCard>
      ),
    },
    {
      key: "startTrial",
      text: "Full Install",
      onRenderField: () => (
        <PlanCard selected={value === "startTrial"}>
          <Title>{intl.formatMessage(freemiumMessages.fullTitle)}</Title>
          <SubTitle>{intl.formatMessage(freemiumMessages.fullSubtitle)}</SubTitle>
          <List>
            <ListItem>
              <strong>{intl.formatMessage(freemiumMessages.fullIntro)}</strong>
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.fullItem1)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.fullItem2)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.fullItem3)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.fullItem4)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.fullItem5)}
            </ListItem>
            <ListItem>
              {" "}
              <Icon iconName="CheckMark" />
              {intl.formatMessage(freemiumMessages.fullItem6)}
            </ListItem>
          </List>
        </PlanCard>
      ),
    },
  ];

  return (
    <div>
      <Container>
        <ChoiceGroup
          value={value}
          onChange={(_, option) => {
            setValue(option?.key || "");
          }}
          options={options}
          styles={{
            flexContainer: {
              display: "flex",
              alignItems: "stretch",
              gap: 16,
              flexDirection: "row",
            },
          }}
        />
      </Container>
    </div>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .ms-ChoiceField-wrapper {
    height: 100%;
  }
`;

const PlanCard = styled.div<{ selected: boolean }>`
  border: 1.5px solid
    ${({ selected, theme }) =>
      selected ? theme?.officeTheme?.palette.accent : theme?.officeTheme?.palette.black};
  border-radius: 4px;
  padding: 16px;
  background-color: ${({ selected, theme }) =>
    selected ? theme?.officeTheme?.palette.themeLighterAlt : theme?.officeTheme?.palette.white};
  min-width: 350px;
  flex: 1;
  display: flex;
  flex-direction: column;
  box-shadow: ${({ selected }) => (selected ? "0 0 0 2px rgba(0, 120, 212, 0.3)" : "none")};
  transition: all 0.2s ease;
  height: 100%;
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 4px;
  color: ${({ theme }) => theme?.officeTheme?.palette.accent};
`;

const SubTitle = styled.div`
  margin-bottom: 20px;
`;

const List = styled.div`
  margin: 0;
  font-size: 14px;
`;

const ListItem = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 10px;
  font-size: 12px;

  i {
    font-size: 20px;
    color: ${({ theme }) => theme?.officeTheme?.palette.accent};
  }
`;
